import { Tabs as ArcoTabs } from '@arco-design/web-react';
import styled from 'styled-components';

const Tabs = styled(ArcoTabs)`
  overflow: visible;
`;

export default Tabs;
